var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.onLine)?_c('div',{staticClass:"marquee",attrs:{"id":"offline-detection-block"}},[_c('p',[_vm._v("LET OP: Geen internetverbinding • Je kunt de analyse wel opslaan en later versturen • Deze melding verdwijnt automatisch zodra er weer verbinding is")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }